import { LOADING } from "../../constants/constant";
import {
  GET_FAILED_COUNTS_REQUESTED,
  GET_FAILED_COUNTS_SUCCESS,
  GET_FAILED_COUNTS_FAILED,
  GET_FAILED_COUNTS_RESET,
} from "../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: false,
};

export default function getFailedCountsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_FAILED_COUNTS_REQUESTED:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case GET_FAILED_COUNTS_SUCCESS:
      let failedMessageData = Object.assign({}, state);
      failedMessageData.status = action.data.status_message;
      failedMessageData.isLoading = false;
      failedMessageData.statusCode = action.data.status_code;
      failedMessageData.response = action.data.data;
      return failedMessageData;

    case GET_FAILED_COUNTS_FAILED:
      return Object.assign({}, state, action.error);

    case GET_FAILED_COUNTS_RESET:
      return initialState;

    default:
      return state;
  }
}
